import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md bg-white rounded-xl shadow p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-3">404 - Page Not Found</h1>
        <p className="text-gray-600 mb-6">
          The page you requested is not available. Please use the navigation menu or go back to login.
        </p>
        <Link
          to="/"
          className="inline-block px-5 py-2 rounded-md text-white"
          style={{ backgroundColor: "var(--app-accent)" }}
        >
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;